// PrivateRoute.js
import React from 'react';
import { Navigate, Route } from 'react-router-dom';

const PrivateRoute = ({ element, isAuthenticated }) => {
  // return isAuthenticated ? element : <Navigate to="/login" replace />;
  return isAuthenticated ? element : <Navigate to="/login" replace />;
};

export default PrivateRoute;